








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Overlay extends Vue {
    @Prop({
        required: true,
        default: false
    }) isShown: boolean;
    @Prop({ default: "" }) opacity: number;

    get backgroundStyle() {
        return `background-color: rgba(0, 0, 0, ${this.opacity})`
    }
}
